import React from 'react';
import classnames from 'classnames';
import { IOutfit } from 'types/outfit';

export function SidebarOutfitSelectorOption({ outfit, disabled }: Props) {
  const {
    name,
    id,
  } = outfit;

  return (
    <option
      value={id}
      disabled={disabled}
      className={classnames(disabled && 'option--disabled-but-legible')}
    >
      {name}
    </option>
  );
}

type OwnProps = {
  outfit: IOutfit,
  disabled: boolean,
};

type Props = OwnProps;

export default SidebarOutfitSelectorOption;